import cn from 'translations/cn.json'
import en from 'translations/en.json'
import de from 'translations/de.json'
import es from 'translations/es.json'
import it from 'translations/it.json'
import pl from 'translations/pl.json'
import jp from 'translations/jp.json'

const globalTranslations = {
  cn,
  en,
  de,
  es,
  it,
  pl,
  jp,
}

const getTranslation = (locale, path) => {
  const keys = path.split('.')
  let result = globalTranslations[locale]

  result = keys.reduce((acc, key) => {
    return acc && key in acc ? acc[key] : null
  }, result)

  return result
}

const generateErrorMessages = (locale) => {
  const translations = (path) =>
    getTranslation(locale, path) || getTranslation('en', path) || ''

  return {
    'any.required': `{{#label}} ${translations('joi.any.required')}`,
    'any.empty': `{{#label}} ${translations('joi.any.empty')}`,
    'string.required': `{{#label}} ${translations('joi.any.required')}`,
    'string.empty': `{{#label}} ${translations('joi.any.empty')}`,
    'string.base': `{{#label}} ${translations('joi.string.base')}`,
    'string.min': `{{#label}} ${translations('joi.string.min')}`,
    'string.max': `{{#label}} ${translations('joi.string.max')}`,
    'string.email': `{{#label}} ${translations('joi.string.email')}`,
    'string.pattern.base': `{{#label}} ${translations('joi.string.regex')}`,
    'number.base': `{{#label}} ${translations('joi.number.base')}`,
    'number.min': `{{#label}} ${translations('joi.number.min')}`,
    'number.max': `{{#label}} ${translations('joi.number.max')}`,
    'array.base': `{{#label}} ${translations('joi.array.base')}`,
    'array.min': `{{#label}} ${translations('joi.array.min')}`,
    'array.max': `{{#label}} ${translations('joi.array.max')}`,
  }
}

export const enErrors = generateErrorMessages('en')
export const deErrors = generateErrorMessages('de')
export const esErrors = generateErrorMessages('es')
export const itErrors = generateErrorMessages('it')
export const plErrors = generateErrorMessages('pl')
export const jpErrors = generateErrorMessages('jp')
export const cnErrors = generateErrorMessages('cn')

export const joiValidationErrors = (locale) => {
  const supportedLocales = ['en', 'de', 'es', 'it', 'pl', 'jp', 'cn']
  const finalLocale = supportedLocales.includes(locale) ? locale : 'en'

  return generateErrorMessages(finalLocale)
}

export default joiValidationErrors
